import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import { FilterConfigService, type FilterDataResult, SelectFilterModel } from '@ui/shared/util-filter';
import type { FoundingMapFilterKey } from '../../types/founding-map-filters';
import { FoundingDataType } from '../../enums/founding-data-type';

@Injectable({ providedIn: 'root' })
export class TypeSelectFilterConfigService extends FilterConfigService<FoundingMapFilterKey, undefined> {

    constructor() {
        super(
            new SelectFilterModel('type', 'Gründungsökosystem', []),
            undefined,
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of({
            data: [
                {
                    value: FoundingDataType.ContactPoint,
                    label: 'Anlaufstelle',
                },
                {
                    value: FoundingDataType.NewFounding,
                    label: 'Neugründung',
                },
                {
                    value: FoundingDataType.Room,
                    label: 'Workspace',
                },
            ],
        });
    }
}
